import { s } from './icon.style'
import React from 'react'
import type { IconProps } from '../iconProps'

export const BookmarkLineIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ size = 16, name = 'icon', color, style, ...props }: IconProps, ref) => {
    return (
      <svg
        viewBox="0 0 24 24"
        css={s}
        style={{ width: size, color, ...style }}
        data-svg-name={name}
        {...props}
        ref={ref}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M17 3H7C5.9 3 5.01 3.9 5.01 5L5.00126 18.9824C5.00074 19.8097 5.9477 20.2797 6.60634 19.7792L12 15.68L17.3949 19.7801C18.0533 20.2805 19 19.811 19 18.984V5C19 3.9 18.1 3 17 3ZM17 17L12.6247 13.4998C12.2595 13.2076 11.7405 13.2076 11.3753 13.4998L7 17V5H17V17Z"
          fill="black"
          fill-opacity="0.87"
        />
      </svg>
    )
  }
)
